/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getRpcCurrentFleetIdResponse200 = {
  data: string
  status: 200
}

export type getRpcCurrentFleetIdResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getRpcCurrentFleetIdResponseSuccess = (getRpcCurrentFleetIdResponse200) & {
  headers: Headers;
};
export type getRpcCurrentFleetIdResponseError = (getRpcCurrentFleetIdResponseDefault) & {
  headers: Headers;
};

export type getRpcCurrentFleetIdResponse = (getRpcCurrentFleetIdResponseSuccess | getRpcCurrentFleetIdResponseError)

export const getGetRpcCurrentFleetIdUrl = () => {




  return `${backendBaseUrl}/rpc/current_fleet_id`
}

/**
 * @summary Call `current_fleet_id()`.
 */
export const getRpcCurrentFleetId = async ( options?: RequestInit): Promise<getRpcCurrentFleetIdResponse> => {

  const res = await fetch(getGetRpcCurrentFleetIdUrl(),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getRpcCurrentFleetIdResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getRpcCurrentFleetIdResponse
}


export type postRpcCurrentFleetIdResponse200 = {
  data: string
  status: 200
}

export type postRpcCurrentFleetIdResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type postRpcCurrentFleetIdResponseSuccess = (postRpcCurrentFleetIdResponse200) & {
  headers: Headers;
};
export type postRpcCurrentFleetIdResponseError = (postRpcCurrentFleetIdResponseDefault) & {
  headers: Headers;
};

export type postRpcCurrentFleetIdResponse = (postRpcCurrentFleetIdResponseSuccess | postRpcCurrentFleetIdResponseError)

export const getPostRpcCurrentFleetIdUrl = () => {




  return `${backendBaseUrl}/rpc/current_fleet_id`
}

/**
 * @summary Call `current_fleet_id()`.
 */
export const postRpcCurrentFleetId = async ( options?: RequestInit): Promise<postRpcCurrentFleetIdResponse> => {

  const res = await fetch(getPostRpcCurrentFleetIdUrl(),
  {
    ...options,
    method: 'POST'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postRpcCurrentFleetIdResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postRpcCurrentFleetIdResponse
}


